import RazorpayPayment from "./RazorpayPayment";

const PaymentPage = () => {
  const handleSuccess = (response) => {
    console.log("Payment Success:", response);
  };

  const handleFailure = (response) => {
    console.log("Payment Failed:", response);
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen">
      <h2 className="text-xl font-bold mb-4">Make a Payment</h2>
      <RazorpayPayment 
        amount={500} // Amount in INR (₹500)
        onSuccess={handleSuccess} 
        onFailure={handleFailure} 
      />
    </div>
  );
};

export default PaymentPage;
